enum Widths {
  PAGE_MAX = '1320px',
  CONTENT_MAX = '840px',
}

export default Widths;
